// --> React
import React from 'react';

// Project Imports
import ViewWrapper from './ViewWrapper';
import {
	HappyClientsSection,
	HomeLandingSection,
	ProfLawnCareSection,
	ServicesSection,
} from 'components';

export default function HomePage() {
	return (
		<ViewWrapper>
			<HomeLandingSection />
			<ProfLawnCareSection />
			<ServicesSection />
			<HappyClientsSection />
		</ViewWrapper>
	);
}
